import { render, staticRenderFns } from "./UnitListItem.vue?vue&type=template&id=5b54bba9&scoped=true&"
import script from "./UnitListItem.vue?vue&type=script&lang=js&"
export * from "./UnitListItem.vue?vue&type=script&lang=js&"
import style0 from "./UnitListItem.vue?vue&type=style&index=0&id=5b54bba9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54bba9",
  null
  
)

component.options.__file = "UnitListItem.vue"
export default component.exports